(function() {

    angular.module( "ATMGurus" )
        .directive("autoFillSync", autoFillSync);

    autoFillSync.$inject = ['$timeout'];

    function autoFillSync($timeout) {

        return {
           require: 'ngModel',
           link: function(scope, elem, attrs, ngModel) {
               var origVal = elem.val();
               $timeout(function () {
                   var newVal = elem.val();
                   if(ngModel.$pristine && origVal !== newVal) {
                       ngModel.$setViewValue(newVal);
                   }
               }, 500);
           }
        }

    };

})()


// WEBPACK FOOTER //
// ./src/app/directives/autofillSync.js